<template>
  <div class="readerBook">
    <div class="container rich-text" v-html="detail.checkItem ? detail.checkItem.content : ''">
    </div>
    <div class="icon">
      <van-image class="img" @click="show = !show" :src="require('@/assets/images/icon_operate_01.png')"></van-image>
      <van-image class="img" @click="shareShow = !shareShow" :src="require('@/assets/images/icon_operate_02.png')"></van-image>
    </div>


    <!-- 目录弹窗开始 -->
    <van-popup
      v-model="show"
      :closeable="false"
      position="right"
      :round="true"
      :style="{ height: '100%',width:'90%' }"
      class="popup popup-1"
    >
      <Empty v-if="detail.contentsList.length===0"></Empty>
      <template v-else>
        <div class="title">目录</div>
        <!-- 一级 -->
        <Collapse v-model="collapse.activeNames" :border="false" class="collapse">
          <CollapseItem
            :name="item.id"
            :border="false"
            v-for="(item) in detail.contentsList"
            :key="item.id"
          >
            <template #title>
              <div class="title">
                {{ item.catalogueTitle }}
              </div>
            </template>

            <template #default>
              <div v-if="item.lessonList.length===0">暂无内容</div>

              <div class="content" v-else>
                <!-- 二级 -->
                <Collapse v-model="collapse.activeNamesCli" :border="false" class="collapse">
                  <CollapseItem :border="false" :name="secItem.id" v-for="(secItem) in item.lessonList" :key="secItem.id">
                  <template #title>
                    <div class="titleCli">
                      {{ secItem.catalogueTitle }}
                    </div>
                  </template>
                  <template #default>
                    <div
                      class="contentCli"
                      v-for="item in secItem.lessonList"
                      :key="item.id"
                      @click="itemClick(item)"
                      :class="{active:item.id === detail.checkItem.id}"
                    >
                      <div class="left">{{ item.catalogueTitle }}</div>
                      <div class="right"></div>
                    </div>
                  </template>
                  </CollapseItem>
                </Collapse>
                <!-- 二级 -->
              </div>
            </template>
          </CollapseItem>
        </Collapse>
        <!-- 一级 -->
      </template>
    </van-popup>
    <!-- 目录弹窗结束 -->

    <!-- 分享弹窗开始 -->
    <van-popup
      v-model="shareShow"
      round
      position="center"
      :style="{ height: '62%',width:'78%' }"
      :overlay-style="{opacity : '0.4'}"
      class="popup popup-2"
    >
      <div class="box">
        <div class="box_title">分享课件</div>
        <div class="box_content">
          <div class="box_text">分享给别人后可通过链接安全浏览课件。</div>

          <div class="box_link" ref="link">{{ link }}</div>
          <div class="box_btn" @click="copyLink">复制链接</div>
          <div class="box_info">注意：创建浏览链接，分享给别人后可通过该链接安全浏览课件，若您分享的内容包含违法违规内容将会被下架，并且可能被平台做封号处理。</div>
        </div>
        <div class="box_bottom"><Checkbox v-model="checked"  checked-color="#1989fa" shape="square" icon-size="16px"/><div class="text">请勾选分享承诺的内容不存在违法违规内容</div></div>
      </div>
    </van-popup>
    <!-- 分享弹窗结束 -->
  </div>
</template>

<script>
import { Checkbox, Collapse, CollapseItem } from 'vant';
import Empty from '../../components/Empty.vue';
export default {
  props: {

  },
  components: {
    Checkbox,
    Collapse,
    CollapseItem,
    Empty
  },
  data () {
    return {
      show: false, // 目录弹窗
      shareShow: false, // 分享弹窗
      detail: {
        contentsList: []
      },

      collapse: {
        activeNames: [], // 第一级
        activeNamesCli: [] // 第二级
      },
      link: '',
      id: '',
      checked: false,
      content: '' // 展示富文本内容
    };
  },
  created () {

  },
  async mounted () {
    const { $route: { query: { id } } } = this;
    this.id = id;
    await this.getDetail();
    this.collapse.activeNames.push(this.detail.contentsList[0].id); // 默认展开第一章
    this.collapse.activeNamesCli.push(this.detail.contentsList[0].lessonList[0].id); // 默认展开第一页
    this.link = location.origin + '/resourceModel/course/' + id;

  },
  methods: {

    /* 获取目录数据 */
    async getDetail () {
      let { $http, id, $route, detail } = this;
      await $http.get('creating/findCatalogue', {
        params: {
          id,
          connectionCode: ''
        },
        showLoading: true,
        loadingText: '加载中'
      }).then(({ data }) => {
        $route.meta.title = data.textTitle;
        detail = data || {};
        this.$set(detail, 'checkItem', {});
        this.detail = detail;

        this.$wxShare({
          // url: window.href, // 网址，默认使用 window.location.href
          title: this.detail.textTitle, // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
          desc: this.detail.textDescribe || '广东教育出版社', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
          imgUrl: this.detail.textPicture // 图片, 默认取网页中第一个img标签
        });

        this.itemClick(detail.contentsList[0].lessonList[0].lessonList[0]); // 默认加载第一章 第一节 第一页的内容
      });
    },

    /* 切换页 */
    itemClick (item) {
      const { detail } = this;
      delete detail.checkItem;
      this.$set(detail, 'checkItem', item);

      this.show = false;
    },

    /* 复制链接 */
    copyLink () {
      const { $utils, checked } = this;
      if (checked) {
        const { $utils } = this;
        $utils.copyValueToClipBoard(this.link).then(async () => {
          $utils.successToast({
            message: '复制成功!',
            onClose: () => {
              this.show = false;
            }
          });
        }, () => {
          $utils.failToast('复制失败!');
        });
      } else {
        $utils.toast('请先勾选协议!');
      }
    }
  }
};
</script>

<style scoped lang="less">
  .readerBook{
    min-height: calc(100vh - 96px);
    background-color: #fff;
    padding: 40px 40px 20px;
    .container{
      .title {
        margin-top: 40px;
        font-size: 40px;
      }
      .content {
        margin-top: 40px;
        font-size: 30px;
        font-weight: 500;
      }
    }
    .icon{
      position: fixed;
      right: 0;
      bottom: 80px;
      right: 40px;
      .img{
        width: 80px;
        height: 80px;
        margin-bottom: 40px;
        &:last-child{
          margin-bottom: 0;
        }
      }
    }

    .popup{
      &.popup-1{
        padding: 60px 40px 0px;
        .title{
          font-size: 40px;
          font-weight: bold;
          line-height: 48px;
          color: #333444;
          margin-bottom: 40px;
        }
        .collapse{
          /deep/.van-collapse-item{
            .van-cell,
            .van-collapse-item__content{
              padding-left:0;
              padding-right:0;
            }
            .van-cell{
              &.van-collapse-item__title--borderless{
                .van-cell__right-icon::before{
                  transform: rotate(0deg)
                }
              }
              &.van-collapse-item__title--expanded{
                .van-cell__right-icon::before{
                  transform: rotate(90deg)
                }
              }
            }
          }
          .title{
            font-size: 30px;
            font-weight: bold;
            color: #333444;
            margin-bottom: 0;
          }
          .titleCli{
            font-size: 28px;
            color: #333444;
          }
          .contentCli{
            display: flex;
            justify-content: space-between;
            font-size: 28px;
            color: #999AAA;
            margin-bottom: 40px;
            &:last-child{
              margin-bottom: 0;
            }
            &.active{
              color: #5FA9FF;
            }
          }
          // &:last-child{
          //   margin-bottom: 0;
          // }
          // .box-title{
          //   font-size: 32px;
          //   font-weight: bold;
          //   line-height: 48px;
          //   color: #999AAA;
          //   margin-bottom: 40px;
          // }
          // .box-item{
          //   font-size: 28px;
          //   line-height: 48px;
          //   color: #333444;
          //   display: flex;
          //   justify-content: space-between;
          //   margin-bottom: 40px;
          //   &:last-child{
          //     margin-bottom: 0;
          //   }
          // }
        }
      }
      &.popup-2{
        padding: 60px 40px 30px;
        .box{
          .box_title{
            font-size: 36px;
            font-weight: bold;
            line-height: 48px;
            color: #333444;
            margin-bottom: 10px;
          }
          .box_content{
            font-size: 26px;
            .box_text{
              color: #999AAA;
              margin-bottom: 40px;
            }
            .box_link{
              width: 100%;
              padding:28px;
              background: #F9FAFC;
              border-radius: 20px;
              color: #5FA9FF;
              margin-bottom: 44px;
              line-height: 48px;
            }
            .box_btn{
              width: 100%;
              height: 80px;
              background: linear-gradient(270deg, #FF7643 0%, #FF5A7A 100%);
              box-shadow: 0px 6px 12px rgba(255, 103, 97, 0.2);
              border-radius: 40px;
              line-height: 80px;
              text-align: center;
              color: #FFFFFF;
              margin-bottom: 44px;
            }
            .box_info{
              font-size: 20px;
              line-height: 40px;
              color: #999AAA;
              margin-bottom: 78px;
            }
          }
          .box_bottom{
            font-size: 20px;
            color: #999999;
            display: flex;
            align-items: center;
            /deep/.van-checkbox{
              .van-icon{
                color: #fff;
              }
            }
            .text{
              margin-left: 12px;
              padding-bottom: 4px;
            }
          }
        }
      }
    }
  }
</style>
